import { useTranslation } from 'react-i18next';
import { config } from '../../config';
import { resources } from '../../resources/resources';

export default function GdprPage() {
  const { t: translate } = useTranslation();

  return (
    <div className="m-panel">
      <iframe
        title={translate(resources.preferences.rights.portability.gDPR)}
        height="1080"
        width="100%"
        style={{ border: 0 }}
        src={config.gdprUrl}
      ></iframe>
    </div>
  );
}
